import * as React from 'react';

export const MAX_TEXT_LENGTH = 80;

type TProps = {
  fullText: string;
  maxMessageLength?: number;
};

type TReturn = {
  text: string;
  isFullTextDisplayed: boolean;
  showFullText: () => void;
};

export const useShowMore = ({
  fullText,
  maxMessageLength = MAX_TEXT_LENGTH,
}: TProps): TReturn => {
  const hasLongText = fullText && fullText.length > maxMessageLength;

  const [isFullTextDisplayed, setIsFullTextDisplayed] = React.useState(
    !hasLongText,
  );

  const showFullText = () => {
    setIsFullTextDisplayed(!isFullTextDisplayed);
  };

  const text =
    hasLongText && !isFullTextDisplayed
      ? `${fullText.slice(0, maxMessageLength)}...`
      : fullText;

  return {
    text,
    isFullTextDisplayed,
    showFullText,
  };
};
